import { useAuthWallets } from "hooks/auth/useAuthWallets";

export const useAuthOwnershipWallet = () => {
    // TODO: we should store walletType along with chainId in user token or local storage
    const { ownershipWallet, walletsReady } = useAuthWallets();

    // Derive important states
    const isLoading = !walletsReady;
    const isComplete = Boolean(ownershipWallet)

    return {
        isLoading,
        isComplete,
    };
};
